var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293693",
    "data-name": "Group 293693",
    transform: "translate(-278 -910)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(278 910)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_293691",
    "data-name": "Group 293691",
    transform: "translate(-10 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "social-icon-x_24",
    d: "M8.646,6.358,14.051,0H12.773L8.079,5.52,4.323,0H0L5.674,8.35,0,15.023H1.279L6.241,9.195l3.96,5.828h4.323L8.639,6.365h0ZM6.888,8.423l-.574-.831L1.744.978H3.713L7.4,6.314l.574.831,4.8,6.938H10.8L6.888,8.416h0Z",
    transform: "translate(290 951)",
    fill: "#222"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0363f323b0abc1137ae29350a6e5a8de.svg";
export { ForwardRef as ReactComponent };